import { render } from "./BordersPage.vue?vue&type=template&id=fd8a0c4e&ts=true"
import script from "./BordersPage.vue?vue&type=script&lang=ts"
export * from "./BordersPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__